export default __webpack_public_path__ + "media/images/images/icons/app-6-2b1b5bc25960eacb80a98d8cfaa6ab30.png";